import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { closeSession } from '@/types/events/close-session';

export default function closeSession(data: closeSession): void {
  const conversationsStore = useConversationsStore();
  conversationsStore.updateOrInsertConversation(data.conversationData);
  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
  }
}
